import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { API_END_POINT } from '../pages/Utils/Constant';
import { IoEye, IoEyeOff } from "react-icons/io5";
import logoimg from "../assets/rootimg/astrotellerlogo.png";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CommonNavbar from '../pages/CommonNavbar';

const ResetPassword = () => {
    const [input, setInput] = useState({
        password: '',
        confirmPassword: ''
    });
    const [passwordVisible, setPasswordVisible] = useState({
        password: false,
        confirmPassword: false
    });
    const [loading, setLoading] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});
    const navigate = useNavigate();
    const { token } = useParams(); // Extract token from URL

    const validateInputs = () => {
        const errors = {};

        // Password validation
        if (!input.password) {
            errors.password = "Password is required.";
        } else if (input.password.length < 6) {
            errors.password = "Password must be at least 6 characters long.";
        }

        // Confirm Password validation
        if (!input.confirmPassword) {
            errors.confirmPassword = "Please confirm your password.";
        } else if (input.password !== input.confirmPassword) {
            errors.confirmPassword = "Passwords do not match.";
        }

        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInput(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const togglePasswordVisibility = (field) => {
        setPasswordVisible(prev => ({
            ...prev,
            [field]: !prev[field]
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateInputs()) {
            return;
        }

        setLoading(true);

        try {
            await axios.post(`${API_END_POINT}auth/reset-pass/${token}`, {
                password: input.password
            });

            // Show success message
            toast.success('Password reset successful!', {
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                onClose: () => {
                    // Redirect to login page
                    navigate('/login');
                }
            });

        } catch (error) {
            console.error('Error resetting password:', error.response?.data || error.message);
            toast.error(error.response?.data?.message || 'Failed to reset password. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-white to-success/40">
            <CommonNavbar />
            <ToastContainer />
            <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-lg">
                {/* Logo */}
                <div className="flex justify-center mb-2">
                    <div className="w-[75%] h-auto mx-auto">
                        <img src={logoimg} alt="Logo" className="w-full h-full object-contain" />
                    </div>
                </div>

                {/* Heading */}
                <h1 className="text-3xl font-semibold text-center text-secondary ">
                    Reset Password
                </h1>
                <p className="text-gray-600 text-center mb-4">
                    Please enter your new password
                </p>

                <form onSubmit={handleSubmit} className="space-y-6">
                    {/* Password Input */}
                    <div className="relative">
                        <input
                            type={passwordVisible.password ? "text" : "password"}
                            placeholder="New Password"
                            name="password"
                            value={input.password}
                            onChange={handleChange}
                            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#6366f1]"
                        />
                        <button
                            type="button"
                            className="absolute right-3 top-1/2 transform -translate-y-1/2"
                            onClick={() => togglePasswordVisibility("password")}
                        >
                            {passwordVisible.password ?
                                <IoEye size={20} color="#6B7280" /> :
                                <IoEyeOff size={20} color="#6B7280" />
                            }
                        </button>
                        {validationErrors.password && (
                            <p className="text-red-500 text-sm mt-1">{validationErrors.password}</p>
                        )}
                    </div>

                    {/* Confirm Password Input */}
                    <div className="relative">
                        <input
                            type={passwordVisible.confirmPassword ? "text" : "password"}
                            placeholder="Confirm New Password"
                            name="confirmPassword"
                            value={input.confirmPassword}
                            onChange={handleChange}
                            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#6366f1]"
                        />
                        <button
                            type="button"
                            className="absolute right-3 top-1/2 transform -translate-y-1/2"
                            onClick={() => togglePasswordVisibility("confirmPassword")}
                        >
                            {passwordVisible.confirmPassword ?
                                <IoEye size={20} color="#6B7280" /> :
                                <IoEyeOff size={20} color="#6B7280" />
                            }
                        </button>
                        {validationErrors.confirmPassword && (
                            <p className="text-red-500 text-sm mt-1">{validationErrors.confirmPassword}</p>
                        )}
                    </div>

                    {/* Submit Button */}
                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-black text-white py-3 rounded-md font-medium hover:bg-secondary transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
                    >
                        {loading ? "Resetting..." : "Reset Password"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ResetPassword;
